class LoadMoreProducts {
  constructor() {
    this.container = document.querySelector('.load-more-container');
    this.button = document.querySelector('.load-more-button');
    this.productList = document.querySelector('.product-list');
    this.isLoading = false;
    this.mode = this.container ? (this.container.dataset.mode || 'load_more') : 'load_more';
    this.observer = null;

    if (this.container && this.productList) {
      this.init();
    }
  }

  init() {
    if (this.mode === 'infinite_scroll') {
      this.initIntersectionObserver();
    } else if (this.button) {
      this.button.addEventListener('click', () => {
        if (!this.isLoading) {
          this.loadMore();
        }
      });
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadMore();
          }
        });
      },
      { rootMargin: '300px' }
    );

    this.observer.observe(this.container);
  }

  pauseObserver() {
    if (this.observer) {
      this.observer.unobserve(this.container);
    }
  }

  resumeObserver() {
    if (this.observer && this.container) {
      this.observer.observe(this.container);
    }
  }

  getNextUrl() {
    if (this.mode === 'infinite_scroll') {
      return this.container.dataset.nextUrl;
    }
    return this.button ? this.button.dataset.nextUrl : null;
  }

  async loadMore() {
    const nextUrl = this.getNextUrl();

    if (!nextUrl || this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.pauseObserver();
    this.showLoader();

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('.product-list .product-card');

      if (newProducts.length > 0) {
        newProducts.forEach((product) => {
          this.productList.appendChild(product);
        });

        const newContainer = doc.querySelector('.load-more-container');
        const newNextUrl = newContainer ? newContainer.dataset.nextUrl : null;

        if (newNextUrl) {
          this.container.dataset.nextUrl = newNextUrl;
          if (this.button) {
            this.button.dataset.nextUrl = newNextUrl;
          }
        } else {
          this.hideContainer();
        }

        this.initializeNewProducts();
        this.revealNewProducts();
      } else {
        this.hideContainer();
      }
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoading = false;
      this.hideLoader();
      this.resumeObserver();
    }
  }

  hideContainer() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.container) {
      this.container.style.display = 'none';
      this.container.style.minHeight = '0';
    }
  }

  showLoader() {
    if (this.container) {
      this.container.classList.add('is-loading');
    }
  }

  hideLoader() {
    if (this.container) {
      this.container.classList.remove('is-loading');
    }
  }

  initializeNewProducts() {
    if (window.theme && window.theme.initProductCards) {
      window.theme.initProductCards();
    }
  }

  revealNewProducts() {
    const revealElements = this.productList.querySelectorAll('[reveal-on-scroll="true"]');

    revealElements.forEach((element, index) => {
      if (element.classList.contains('reveal')) {
        return;
      }
      element.removeAttribute('reveal-on-scroll');
      setTimeout(() => {
        element.classList.add('reveal');
      }, index * 50);
    });
  }
}

function initLoadMore() {
  new LoadMoreProducts();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadMore);
} else {
  initLoadMore();
}

document.addEventListener('shopify:section:load', initLoadMore);
